import {
    OUTWARD_BRAND_FAILURE,
    OUTWARD_BRAND_REQUEST,
    OUTWARD_BRAND_SUCCESS,
} from "../actions/actionTypes";

const initialState = {
    outWardBrand: [],
    loading: false,
    error: null,
};

const ourWardBrandReducer = (state = initialState, action) => {
    switch (action.type) {
        case OUTWARD_BRAND_REQUEST:
            return { ...state, loading: true, error: null };
        case OUTWARD_BRAND_SUCCESS:
            return { ...state, loading: false, outWardBrand: action.payload };
        case OUTWARD_BRAND_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default ourWardBrandReducer;
